import { AutoSizer } from 'react-virtualized';

import { GridAutoSizerProps } from './types';

import cn from './Grid.module.scss';

export const GridAutoSizer = ({ children }: GridAutoSizerProps) => {
  return (
    <div className={cn.grid}>
      <AutoSizer>
        {({ height, width }) => <div style={{ height, width }}>{children}</div>}
      </AutoSizer>
    </div>
  );
};
